import { AfterViewInit, Component, OnDestroy, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { ApiService } from '../../../../../shared/services/api.service';
import { API_ENDPOINTS } from '../../../../../shared/utils/const';
import { Router } from '@angular/router';
import { CommonService } from '../../../../../shared/services/common.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { IARepositoryDashboard } from '../../../../../shared/models/IARepositoryDashboard';
import { MatTableDataSource } from '@angular/material/table';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { BehaviorSubject, catchError, debounceTime, distinctUntilChanged, filter, map, merge, of, Subject, Subscription, switchMap, takeUntil } from 'rxjs';

import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-msmerepositorycontent',
  templateUrl: './msmerepositorycontent.component.html',
  styleUrl: './msmerepositorycontent.component.css'
})
export class MsmerepositorycontentComponent implements AfterViewInit, OnDestroy {

  private loadDataSubscription: Subscription = new Subscription();
  private destroy$: Subject<void> = new Subject<void>();


  RepositoryDetailsData: any[] = [];
  msMeUserName = sessionStorage.getItem('userId');

  length: number = 0;
  pageSize: number = 20;
  displayedData: any[] = [];
  reportData: any[] = [];
  allrecord: any[] = [];
  pageSizeOptions: number[] = [10, 20, 50, 100];
  hidePageSize = false;
  showPageSizeOptions = true;
  showFirstLastButtons = true;
  disabled = false;
  pageIndex = 0;
  pageEvent!: PageEvent;
  DtoPagination =
    {
      "MSMEId": this.msMeUserName,
      "PageNumber": 1,
      "PageSize": 20,
      "SortColumn": "",
      "SortDirection": "",
      "SearchTerm": "",
      "SearchCol": ""
    }
  dataSource!: MatTableDataSource<IARepositoryDashboard>
  //displayedColumns: string[] = ['Sr.No', 'IAUserName', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download']
  displayedColumns: string[] = ['SrNo', 'Name', 'Intervention', 'Interest', 'CreatedDate', 'DocumentName', 'Download'];

  @ViewChild(MatPaginator) pagination!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  term$ = new BehaviorSubject<string>('');
  codeSearch$ = new BehaviorSubject<any>(null);
  nameSearch$ = new BehaviorSubject<any>(null);
  searchText: string = '';
  codeSearchKey: string = '';
  nameSearchKey: string = '';


  constructor(
    private apiService: ApiService, private router: Router, public commonService: CommonService, private toastrService: ToastrService) { }

  form1 = new FormGroup({

    searchControl: new FormControl('', [Validators.pattern(this.commonService.searchFilter)])

  })

  async ngOnInit(): Promise<void> {    
    this.DtoPagination.PageSize = 20;
    this.DtoPagination.SearchTerm = this.commonService.searchText;
    //await this.loadRepositoryDetails();
  }

  ngAfterViewInit() {
    this.loadRepositoryDetails();
  }


  //async loadRepositoryDetails(): Promise<void> {
  //  const MSMEId = this.msMeUserName;
  //  this.apiService.getRequest(API_ENDPOINTS.MSME.GETIAREPOSITORYDETAILS, this.DtoPagination).subscribe(
  //    (result) => {
  //      if (result.status) {
  //        this.length = result['totalRecords'];
  //        this.RepositoryDetailsData = result.data;
  //      }
  //    }
  //  );
  //}

  //async loadRepositoryDetails(): Promise<void> {
  //  // Reset pagination on sort change
  //  this.sort.sortChange.subscribe(() => this.pagination.pageIndex = 0);

  //  // Combine sort changes, search term debounce, and pagination
  //  merge(
  //    this.sort.sortChange,
  //    this.term$.pipe(debounceTime(1100), distinctUntilChanged()),
  //    this.pagination.page
  //  )
  //    .pipe(
  //      filter((searchTerm) => searchTerm != null), // Only process if searchTerm exists
  //      switchMap(() => {
  //        // Reset pagination on new search term
  //        if (this.commonService.searchText) {
  //          this.pagination.pageIndex = 0;
  //        }

  //        // Update DTO for API call
  //        this.DtoPagination.SortColumn = this.sort.active;
  //        this.DtoPagination.SortDirection = this.sort.direction;
  //        this.DtoPagination.SearchCol = this.commonService.searchText;

  //        // Call the API and handle potential errors
  //        return this.apiService
  //          .getRequest(
  //            API_ENDPOINTS.MSME.GETIAREPOSITORYDETAILS,
  //            this.DtoPagination
  //          )
  //          .pipe(catchError(() => of(null))); // Return null on error to prevent crashing
  //      }),
  //      map((result) => {
  //        if (result && result.status) {
  //          this.length = result['totalRecords']; // Update total records for paginator
  //          //this.interventions = result.data.item1; // Update interventions data
  //          return result.data; // Return repository details
  //        }
  //        return [];
  //      })
  //    )
  //    .subscribe((repositoryDetails) => {
  //      this.RepositoryDetailsData = repositoryDetails; // Update the repository data
  //      this.adjustPaginator(); // Adjust paginator after data load
  //    });
  //}

  loadRepositoryDetails() {
    if (!this.pagination) return;
    // Unsubscribe from previous subscription to prevent multiple API calls
    this.loadDataSubscription.unsubscribe();

    // Reset subscription with a new request
    this.loadDataSubscription = merge(
      this.sort.sortChange.pipe(takeUntil(this.destroy$)),
      this.term$.pipe(debounceTime(1100), distinctUntilChanged(), takeUntil(this.destroy$)),
      this.pagination.page.pipe(takeUntil(this.destroy$))
    )
      .pipe(
        filter(searchTerm => searchTerm != null),
        switchMap(() => {
          this.pagination.pageIndex = 0;
          this.DtoPagination.SortColumn = this.sort.active;
          this.DtoPagination.SortDirection = this.sort.direction;
          this.DtoPagination.SearchCol = this.commonService.searchText;

          return this.apiService
            .getRequest(API_ENDPOINTS.MSME.GETIAREPOSITORYDETAILS,this.DtoPagination)
            .pipe(catchError(() => of(null)));
        }),
        map(resp => {
          if (resp && resp.status) {
            this.length = resp['totalRecords'];
          }
          return resp?.data || {};
        })
      )
      .subscribe(data => {
        this.RepositoryDetailsData = data;
        this.adjustPaginator();
      });
  }

  ngOnDestroy() {
    this.loadDataSubscription.unsubscribe();
    this.destroy$.next();
    this.destroy$.complete();
  }

  adjustPaginator() {
    const totalPages = Math.ceil(this.length / this.pageSize);

    // If the current page index is greater than or equal to total pages, move to the last page
    if (this.pageIndex >= totalPages) {
      this.pageIndex = totalPages - 1; // Set to the last valid page
      this.DtoPagination.PageNumber = this.pageIndex + 1; // Update for 1-based pagination
    }

    // Update the paginator with the adjusted page index
    this.pagination.pageIndex = this.pageIndex;
  }

  onDownload(filePath: string, fileName: string) {
    this.apiService.downloadFile(filePath).subscribe({
      next: (blob) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    });
  }

  onSearchChange(e: any) {
    this.DtoPagination.SearchTerm = e.target.value;
    this.DtoPagination.PageNumber = 1;
    this.loadRepositoryDetails();
  }

  onPageChange(e: PageEvent) {
    this.pageEvent = e;
    this.length = e.length;
    this.pageSize = e.pageSize;
    this.pageIndex = e.pageIndex;

    this.DtoPagination.PageNumber = e.pageIndex + 1;
    this.DtoPagination.PageSize = e.pageSize;
    this.loadRepositoryDetails();
  }
  onSearchClick(searchValue: string): void {
    const searchControl = this.form1.get('searchControl');


    if (searchControl?.value && searchValue.trim() !== '') {
      this.DtoPagination.SearchTerm = searchValue.trim();
      this.loadRepositoryDetails();
    } else if (searchValue.trim() === '') {
      searchControl?.markAsTouched();
    } else {
      searchControl?.markAsTouched();
    }
  }


  exportToExcel(): void {
    const fileName = 'IA_Repository_List.xlsx';

    const DtoPagination = {
      MSMEId: sessionStorage.getItem('userId'),
      PageNumber: 1,
      PageSize: 9999999,
      SortColumn: this.sort.active,
      SortDirection: this.sort.direction,
      SearchTerm: "",
      SearchCol: this.commonService.searchText,
    };

    this.apiService.getRequest(API_ENDPOINTS.MSME.GETIAREPOSITORYDETAILS, DtoPagination).subscribe(
      result => {
        if (result.status) {
          this.allrecord = result.data;

          if (!this.allrecord || this.allrecord.length === 0) {
            this.toastrService.error('No data available to export.');
            return;
          }

          const excelData = this.allrecord.map((item, index) => ({
            'Sr.No': item.rowNum,
            'Name': item.iaUserName,
            'Intervention': item.interventionName,
            'Interest': item.interestName,
            'Created Date': item.createdDate,
            'Document Name': item.documentName,
            'Download': item.documentPath ? 'Available' : 'Not Available',
          }));

          const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(excelData);

          const columnWidths = [
            { wch: 10 }, // Sr.No            
            { wch: 25 }, // Name
            { wch: 20 }, // Intervention
            { wch: 20 }, // Interest
            { wch: 20 }, // Created Date
            { wch: 30 }, // Document Name
            { wch: 15 }, // Download Status
          ];
          worksheet['!cols'] = columnWidths;

          const workbook: XLSX.WorkBook = {
            Sheets: { 'IA Repository List': worksheet },
            SheetNames: ['IA Repository List'],
          };

          const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array',
          });

          const data: Blob = new Blob([excelBuffer], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
          });

          saveAs(data, fileName);
          this.toastrService.success('Excel exported successfully!');
        }
      }
    );
  }
  
  saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8',
    });
    saveAs(data, fileName);
  }

}
